/**
 * External dependencies
 */
import {
  SET_MESSAGE_INITIALIZE,
  SET_MESSAGE_DIALOG,
  REMOVE_MESSAGE_DIALOG,
  SET_MESSAGE_CONFIRM,
  REMOVE_MESSAGE_CONFIRM,
  SET_MESSAGE_SNACK,
  REMOVE_MESSAGE_SNACK
} from '@naruto/naruto-reducers/src/reducers/message/actions';

/**
 * Internal dependencies
 */
import {
  Dispatch,
  ThunkAction,
  Models,
  MiddleWare,
  MessageDialogObject,
  MessageConfirmObject,
  MessageSnackObject
} from './types';

/* Initial */
export const postMessageInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_MESSAGE_INITIALIZE());
  };

/* Dialog Action */
export const postMessageDialog =
  (data: MessageDialogObject): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_MESSAGE_DIALOG({
        dialog: data
      })
    );
  };
export const removeMessageDialog =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(REMOVE_MESSAGE_DIALOG());
  };

/* Confirm Action */
export const postMessageConfirm =
  (data: MessageConfirmObject): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_MESSAGE_CONFIRM({
        confirm: data
      })
    );
  };
export const removeMessageConfirm =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(REMOVE_MESSAGE_CONFIRM());
  };

/* Snack Action */
export const postMessageSnack =
  (data: MessageSnackObject): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_MESSAGE_SNACK({
        snack: data
      })
    );
  };
export const removeMessageSnack =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(REMOVE_MESSAGE_SNACK());
  };
